import { gql } from '@apollo/client';
/**
 * @const StoreCartFeesQuery
 * @since 1.0.0
 * Account fees a store cart would get, before the deal exists.
 */
export const StoreCartFeesQuery = gql `
  query StoreCartFeesQuery($input: StoreCartFeesInput!) {
    storeCartFees(input: $input) {
      description
      price
      fee {
        id
        title
        infos
      }
    }
  }
`;
